import React, { forwardRef, useRef } from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import DateRangeIcon from '@mui/icons-material/DateRange';

import 'react-datepicker/dist/react-datepicker.css';

const useStyles: any = makeStyles(() => {
  return {
    dateIcon: {
      position: 'absolute',
      right: 18,
      top: 18,
      width: 20,
      height: 20,
      zIndex: 1
    }
  };
});

const CustomDatePicker = forwardRef(function CustomDatePicker(props: any, ref) {
  const { component: Component, fieldRef, handleOnChange, ...rest } = props;
  React.useImperativeHandle(ref, () => ({
    focus: () => void 0
  }));

  return <Component {...rest} ref={fieldRef} onChange={handleOnChange} />;
});

const CustomDatePickerField = props => {
  const classes = useStyles();
  const {
    label,
    name,
    value,
    minDate,
    maxDate,
    minTime,
    maxTime,
    disabled = false,
    onChangeHandler,
    error,
    helperText,
    includeTimes,
    showTimeSelect,
    dateFormat
  } = props;
  const fieldRef = useRef(null);
  const onChange = date => {
    if (date && !isNaN(date.getTime())) {
      return onChangeHandler(moment(date).format('YYYY-MM-DD[T]HH:mm'));
    }
  };
  const selected = value !== 'Invalid date' ? new Date(value) : null;
  const timeConstraintProps: any = {};

  if (minDate) {
    timeConstraintProps.minDate = minDate;
  }
  if (maxDate) {
    timeConstraintProps.maxDate = maxDate;
  }
  if (minTime) {
    timeConstraintProps.minTime = minTime;
    if (!maxTime) {
      timeConstraintProps.maxTime = moment().add(20, 'years');
    }
  }
  if (maxTime) {
    timeConstraintProps.maxTime = maxTime;
    if (!minTime) {
      timeConstraintProps.minTime = moment().subtract(20, 'years');
    }
  }
  return (
    <>
      {disabled && (
        <div style={{ position: 'relative', zIndex: 0 }}>
          <DateRangeIcon className={classes.dateIcon} />
          <TextField
            fullWidth
            name={name}
            label={label}
            disabled={disabled}
            InputLabelProps={{ shrink: true }}
            value={moment(selected).format('MM/DD/YYYY, hh:mm a')}
          />
        </div>
      )}
      {!disabled && (
        <div style={{ position: 'relative', zIndex: 2 }}>
          <DateRangeIcon className={classes.dateIcon} />
          <TextField
            fullWidth
            name={name}
            label={label}
            disabled={disabled}
            InputProps={{
              inputProps: {
                fieldRef,
                showTimeSelect: showTimeSelect,
                timeIntervals: 5,
                component: DatePicker,
                injectTimes: includeTimes,
                includeTimes: includeTimes,
                selected: selected,
                dateFormat: dateFormat ? dateFormat : 'MM/dd/yyyy, hh:mm a',
                ...timeConstraintProps,
                handleOnChange: onChange
              },
              inputComponent: CustomDatePicker
            }}
            error={error}
            helperText={helperText}
            InputLabelProps={{
              shrink: true
            }}
            className={classes.customDatePicker}
          />
        </div>
      )}
    </>
  );
};

export default CustomDatePickerField;
